import { i18n } from "@/plugin/i18n";

const CpfHelpers = {
  checkCpf: (rule, value, callback) => {
    const vm = this;
    if (!value) {
      return callback(new Error(i18n.tc("cpf-obrigatorio")));
    }

    const valid = CpfHelpers.validate(value);
    if (!valid) {
      return callback(new Error(i18n.tc("cpf-invalido")));
    }
    callback();
  },
  validate: function (value) {
    const cpf = value.replace(/\D/g, '');
    if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    var result = true;
    [9, 10].forEach(function (j) {
      var soma = 0, r;
      cpf.split(/(?=)/).splice(0, j).forEach(function (e, i) {
        soma += parseInt(e) * ((j + 2) - (i + 1));
      });
      r = soma % 11;
      r = (r < 2) ? 0 : 11 - r;
      if (r != cpf.substring(j, j + 1)) result = false;
    });
    return result;
  },
};

export default CpfHelpers;

export { CpfHelpers };

